<script>
  import { apiFetch } from "../../lib/api.js";
    import { user } from "../../stores/user";
    import { BASE_URL } from "../../stores/BASE_URL";
    import CardContent from "../CardContent.svelte";
    import { formatNumber } from "../../services/formatNumber";

    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    export let id_usuario = 0;

    let isLoading = false;
    let isSettings = false;

    let disabled_masivos = true;
    let disabled_filtros = true;

    let usuario = {
        id_usuario: id_usuario,
        id_cliente: "0",
        usuario: "",
        nombres: "",
        consultas_contrato: "0",
        consultas: "0",
        plan: "",
        razon_social: "",
        consultas_masivos: "0",
        consultas_filtros: "0",
    };

    const PLANES_LIMITES = {
        "Bronze I": { minimo: 25, maximo: 500_000, minimo_masivo: 0, maximo_masivo: 0 },
        "Bronze II": { minimo: 25, maximo: 500_000, minimo_masivo: 0, maximo_masivo: 0 },
        "Silver I": { minimo: 100, maximo: 500_000, minimo_masivo: 100, maximo_masivo: 500_000 },
        "Silver II": { minimo: 100, maximo: 500_000, minimo_masivo: 100, maximo_masivo: 500_000 },
        "Gold I": { minimo: 500, maximo: 500_000, minimo_masivo: 500, maximo_masivo: 500_000 },
        Platinum: { minimo: 15_000, maximo: 500_000, minimo_masivo: 15_000, maximo_masivo: 500_000 },
        Signature: { minimo: 15_000, maximo: 500_000, minimo_masivo: 15_000, maximo_masivo: 500_000 },
        "Ilimitado I": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 0, maximo_masivo: 0 },
        "Ilimitado II": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 10_000, maximo_masivo: 3_000_000 },
        "Ilimitado III": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 10_000, maximo_masivo: 3_000_000 },
        "Ilimitado IV": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 10_000, maximo_masivo: 3_000_000 },
        "Gold II": { minimo: 500, maximo: 100_000, minimo_masivo: 500, maximo_masivo: 500_000 },
        "Grupal III": { minimo: 25, maximo: 500_000, minimo_masivo: 25, maximo_masivo: 500_000 },
        "Grupal II": { minimo: 25, maximo: 500_000, minimo_masivo: 25, maximo_masivo: 500_000 },
        "Grupal I": { minimo: 25, maximo: 500_000, minimo_masivo: 25, maximo_masivo: 500_000 },
        API: { minimo: 50_000, maximo: 2_000_000, minimo_masivo: 0, maximo_masivo: 0 },
    };

    function dispatchClosed() {
        dispatch("closed");
    }

    const getUsuario = async () => {
        isLoading = true;
        const response = await apiFetch(`${BASE_URL}usuario.php?action=getUsuario&id=${id_usuario}`);
        const resp = await response.json();
        const tmp_usuario = resp.data;
        usuario.id_cliente = tmp_usuario.id_cliente;
        usuario.usuario = tmp_usuario.usuario;
        usuario.nombres = tmp_usuario.nombres;
        usuario.consultas_contrato = formatNumber(tmp_usuario.consultas_contrato);
        usuario.consultas = formatNumber(tmp_usuario.consultas);
        usuario.plan = tmp_usuario.plan;
        usuario.razon_social = tmp_usuario.razon_social;

        usuario.consultas_masivos = resp.data.consultas_masivas;
        usuario.consultas_filtros = "0";

        generarPlan();

        isLoading = false;
    };

    const generarPlan = () => {
        disabled_filtros = true;
        disabled_masivos = true;

        usuario.consultas_masivos = "0";
        usuario.consultas_filtros = "0";

        if (
            usuario.plan == "Silver I" ||
            usuario.plan == "Silver II" ||
            usuario.plan == "Gold I" ||
            usuario.plan == "Platinum" ||
            usuario.plan == "Signature" ||
            usuario.plan == "Gold II" ||
            usuario.plan == "Grupal III" ||
            usuario.plan == "Grupal II" ||
            usuario.plan == "Grupal I"
        ) {
            usuario.consultas_masivos = usuario.consultas_contrato;
        } else {
            usuario.consultas_masivos = "0";
        }

        // Filtros
        if (usuario.plan == "Gold II" || usuario.plan == "Grupal III" || usuario.plan == "Signature") {
            usuario.consultas_filtros = usuario.consultas_contrato;
        } else {
            usuario.consultas_filtros = "0";
        }

        // Planes con filtros editables
        if (usuario.plan == "Ilimitado III" || usuario.plan == "Ilimitado IV") {
            disabled_filtros = false;
        }

        // Planes con masivos editables
        if (usuario.plan == "Ilimitado II" || usuario.plan == "Ilimitado III" || usuario.plan == "Ilimitado IV") {
            disabled_masivos = false;
        }
    };

    const validar = () => {
        let validate = true;
        if (usuario.plan == "API") {
            alert("No se puede generar el plan API");
            validate = false;
        }

        // if (
        //     Number(usuario.consultas_contrato.replace(/[^\d.]/g, "")) < PLANES_LIMITES[usuario.plan].minimo ||
        //     Number(usuario.consultas_contrato.replace(/[^\d.]/g, "")) > PLANES_LIMITES[usuario.plan].maximo
        // ) {
        //     alert(
        //         `Para el plan ${usuario.plan} el valor de consultas contratadas debe estar entre ${formatNumber(PLANES_LIMITES[usuario.plan].minimo)} y ${formatNumber(PLANES_LIMITES[usuario.plan].maximo)}`,
        //     );
        //     validate = false;
        // }

        // if (
        //     Number(usuario.consultas_masivos.replace(/[^\d.]/g, "")) < PLANES_LIMITES[usuario.plan].minimo_masivo ||
        //     Number(usuario.consultas_masivos.replace(/[^\d.]/g, "")) > PLANES_LIMITES[usuario.plan].maximo_masivo
        // ) {
        //     alert(
        //         `Para el plan ${usuario.plan} el valor de consultas masivas debe estar entre ${formatNumber(PLANES_LIMITES[usuario.plan].minimo_masivo)} y ${formatNumber(PLANES_LIMITES[usuario.plan].maximo_masivo)}`,
        //     );
        //     validate = false;
        // }

        return validate;
    };

    const handleSubmit = async () => {
        isSettings = true;
        if (validar()) {
            const formData = new FormData();
            formData.append("id_usuario", usuario.id_usuario);
            formData.append("id_cliente", usuario.id_cliente);
            formData.append("usuario", usuario.usuario);
            formData.append("plan", usuario.plan);
            formData.append("consultas", usuario.consultas.replace(/[^\d.]/g, ""));
            formData.append("consultas_contrato", usuario.consultas_contrato.replace(/[^\d.]/g, ""));
            formData.append("consultas_masivos", usuario.consultas_masivos.replace(/[^\d.]/g, ""));
            formData.append("consultas_filtros", usuario.consultas_filtros.replace(/[^\d.]/g, ""));
            formData.append("action", "setUsuarioPlan");
            formData.append("session_id_usuario", $user.idUsuario);

            const response = await apiFetch(`${BASE_URL}usuario.php`, {
                method: "POST",
                body: formData,
            });

            const resp = await response.json();
            if (resp.status == "success") {
                alert("Plan modificado");
                dispatchClosed();
            } else {
                alert(resp.message);
            }
        }
        isSettings = false;
    };

    const handlePlan = () => {
        generarPlan();
    };

    const handleConsultasContratoInput = (event) => {
        const formattedValue = formatNumber(event.target.value);
        usuario.consultas_contrato = formattedValue;
        generarPlan();
    };

    const handleConsultasInput = (event) => {
        const formattedValue = formatNumber(event.target.value);
        usuario.consultas = formattedValue;
        generarPlan();
    };

    const handleConsultasMasivosInput = (event) => {
        const formattedValue = formatNumber(event.target.value);
        usuario.consultas_masivos = formattedValue;
    };

    const handleConsultasFiltrosInput = (event) => {
        const formattedValue = formatNumber(event.target.value);
        usuario.consultas_filtros = formattedValue;
    };

    getUsuario();
</script>

<CardContent title="Cambiar plan">
    <form on:submit|preventDefault={handleSubmit}>
        <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
                <label class="w-100">
                    <span class="form-label">Usuario</span>
                    <input class="form-control" type="text" bind:value={usuario.usuario} autocomplete="off" disabled />
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
                <label class="w-100">
                    <span class="form-label"> Nombres </span>
                    <input type="text" class="form-control" bind:value={usuario.nombres} disabled />
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
                <label class="w-100">
                    <span class="form-label">Cliente</span>
                    <select class="form-select" bind:value={usuario.id_cliente} disabled>
                        <option value={usuario.id_cliente}>{usuario.razon_social}</option>
                    </select>
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
                <label class="w-100">
                    <span class="form-label"> Plan </span>
                    <select class="form-select form-select-primary" bind:value={usuario.plan} on:change={handlePlan}>
                        <option value="Bronze I">Bronze I</option>
                        <option value="Bronze II">Bronze II</option>
                        <option value="Silver I">Silver I</option>
                        <option value="Silver II">Silver II</option>
                        <option value="Gold I">Gold I</option>
                        <option value="Gold II">Gold II</option>
                        <option value="Platinum">Platinum</option>
                        <option value="Signature">Signature</option>
                        <option value="Ilimitado I">Ilimitado I</option>
                        <option value="Ilimitado II">Ilimitado II</option>
                        <option value="Ilimitado III">Ilimitado III</option>
                        <option value="Ilimitado IV">Ilimitado IV</option>
                        <option value="Grupal III">Grupal III</option>
                        <option value="Grupal II">Grupal II</option>
                        <option value="Grupal I">Grupal I</option>
                        <option value="API" disabled>API</option>
                    </select>
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
                <label class="w-100">
                    <span class="form-label">Consultas contratadas</span>
                    <input class="form-control" type="text" bind:value={usuario.consultas_contrato} on:input={handleConsultasContratoInput} />
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
                <label class="w-100">
                    <span class="form-label">Consultas</span>
                    <input class="form-control" type="text" bind:value={usuario.consultas} on:input={handleConsultasInput} />
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
                <label class="w-100">
                    <span class="form-label">Cant. Masivos</span>
                    <input class="form-control" type="text" bind:value={usuario.consultas_masivos} disabled={disabled_masivos} on:input={handleConsultasMasivosInput} />
                </label>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
                <label class="w-100">
                    <span class="form-label">Cant. Filtros</span>
                    <input class="form-control" type="text" bind:value={usuario.consultas_filtros} disabled={disabled_filtros} on:input={handleConsultasFiltrosInput} />
                </label>
            </div>

            <div class="col-12 mb-3 text-end">
                {#if isSettings}
                    <button class="btn btn-primary" disabled> Modificando plan... </button>
                {:else}
                    <button class="btn btn-primary">Guardar</button>
                {/if}
            </div>
        </div>
    </form>
</CardContent>
